import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import Modal from 'components/Modal';
import Tooltip from 'components/Tooltip';

const DeleteKit = createReactClass({
  propTypes: {
    name: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  getInitialState() {
    return {
      showConfirmation: false,
      deleting: false,
      focused: false,
    };
  },

  handleOpened() {
    this.setState({showConfirmation: true});
  },

  handleClosed() {
    this.setState({showConfirmation: false});
  },

  handleDeleted() {
    this.setState({deleting: true});
  },

  handleFocused() {
    this.setState({focused: !this.state.focused});
  },

  render() {
    const deleteClassName = classnames(
      'btn',
      'btn-lg',
      'btn-danger',
      {disabled: this.state.deleting}
    );

    const deleteLabel = (this.state.deleting) ? 'Deleting...' : 'Delete';

    const popover = (this.state.focused) ? <Tooltip content="Delete Kit" icon="ficon-trash" /> : null;

    return (
      <div className="asset-remove cursor-pointer" onClick={this.handleOpened} onMouseOver={this.handleFocused} onMouseOut={this.handleFocused}>
        {popover}
        <i className="ficon ficon-trash" />
        <Modal contentLabel="Confirm delete kit" isOpen={this.state.showConfirmation} onRequestClose={this.handleClosed}>
          <div className="modal-content">
            <div className="modal-header bg-danger dashed dashed-bottom m-xs-b-xs p-xs-b-sm">
              <button type="button" className="close close-dangle" onClick={this.handleClosed}>
                <span aria-hidden="true">
                  <i className="ficon ficon-times" /></span>
                <span className="sr-only">Close</span>
              </button>
              <h3 className="modal-title">Confirm Delete Kit</h3>
            </div>
            <div className="modal-body">
              <div className="well bg-body text-lg">
                <i className="ficon ficon-warning ficon-2x pull-left m-xs-t-sm m-xs-b-xl p-xs-r-sm" />
                <p>
                  Are you sure you would like to delete this kit? These icons will no longer load on any websites.
                </p>
                This action cannot be undone.
              </div>
              <table className="table text-xl">
                <tbody>
                  <tr>
                    <th className="min-width text-nowrap p-xs-r-xl">Kit Name</th>
                    <td>{this.props.name}</td>
                  </tr>
                  <tr>
                    <th className="min-width text-nowrap p-xs-r-xl">Kit ID</th>
                    <td>{this.props.token}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="modal-footer bg-body">
              <a href="#" className="btn btn-lg btn-secondary" onClick={this.handleClosed}>Cancel</a>
              <a href={`kits/${this.props.token}`} className={deleteClassName} data-method="delete" rel="nofollow" onClick={this.handleDeleted}>{deleteLabel}</a>
            </div>
          </div>
        </Modal>
      </div>
    );
  },
});

export default DeleteKit;



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/DeleteKit.js